// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PhoneNumber test Match con el snapshot 1`] = `""`;
